import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    verifyUrl: String,
    redirectionUrl: String
  }

  connect() {
    fetch(this.verifyUrlValue, {
      method: 'GET',
      credentials: 'include',
    })
      .then(response => {
        if(response.status === 200) {
          window.location.href = this.redirectionUrlValue
        }
      })
  }
}
